import Vue from 'vue'
import VueI18n from 'vue-i18n'
import de from '@/../../locales/de.yml'
import en from '@/../../locales/en.yml'
import cz from '@/../../locales/cz.yml'
import fr from '@/../../locales/fr.yml'
import nl from '@/../../locales/nl.yml'
import pl from '@/../../locales/pl.yml'

Vue.use(VueI18n)

export default new VueI18n({
  locale: window.top.document.getElementById('ledconfigurator')?.getAttribute('locale') || 'de',
  fallbackLocale: 'de',
  messages: { en, de, cz, fr, nl, pl }
})
